"use client";

import { useEffect } from "react";

export function DynamicFavicon() {
	useEffect(() => {
		// Check if we're in production mode
		const isProd = process.env.NODE_ENV === "production";
		const faviconUrl = isProd ? "/favicon.jpg" : "/favicon-dev.jpg";

		// Function to update favicon
		const updateFavicon = () => {
			// Remove all existing favicon links to avoid conflicts
			const existingLinks = document.querySelectorAll('link[rel*="icon"]');
			existingLinks.forEach(link => link.remove());

			// Create primary favicon link (JPG)
			const link = document.createElement("link");
			link.rel = "icon";
			link.type = "image/jpg";
			link.href = faviconUrl;
			document.head.appendChild(link);

			// Create shortcut icon link for older browsers
			const shortcutLink = document.createElement("link");
			shortcutLink.rel = "shortcut icon";
			shortcutLink.type = "image/jpg";
			shortcutLink.href = faviconUrl;
			document.head.appendChild(shortcutLink);
		};

		// Update favicon immediately
		updateFavicon();

		// Also update after a short delay to ensure it sticks
		const timeoutId = setTimeout(updateFavicon, 100);

		return () => {
			clearTimeout(timeoutId);
		};
	}, []);

	return null;
}
